// src/pages/SignIn.tsx

import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate, Link } from 'react-router-dom';
import { logAuthenticationEvent } from '../lib/audit/auditLogger';

const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      // Get user role from Firestore
      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);
      
      let role = 'client'; // default
      if (userDoc.exists()) {
        role = userDoc.data().role || 'client';
      }
      
      // Log successful login
      logAuthenticationEvent(
        user.uid,
        user.email || email,
        role as 'admin' | 'staff' | 'client',
        'user_login',
        true
      ).catch((err) => console.error('Failed to log authentication event:', err));
      
      // Redirect based on role
      switch (role) {
        case 'admin':
          navigate('/admin-dashboard');
          break;
        case 'staff':
          navigate('/staff-dashboard');
          break;
        default:
          navigate('/client-dashboard');
      }
    } catch (err: any) {
      setError(err.message);
      
      // Log failed login attempt
      logAuthenticationEvent(
        '',
        email,
        'client', // Default role for failed login
        'failed_login',
        false,
        err.message
      ).catch((logErr) => console.error('Failed to log failed login:', logErr));
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '2rem auto', padding: '20px' }}>
      <h2>Client Sign In</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
          />
        </div>

        {error && <p style={{ color: 'red' }}>{error}</p>}

        <button 
          type="submit"
          style={{ 
            backgroundColor: '#007bff', 
            color: 'white', 
            padding: '10px 20px', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            width: '100%'
          }}
        >
          Sign In
        </button>
      </form>
      
      <p style={{ textAlign: 'center', marginTop: '20px' }}>
        Don't have an account? <Link to="/sign-up">Sign Up</Link>
      </p>
      
      <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '0.875rem', color: '#666' }}>
        By signing in, you agree to our{' '}
        <Link to="/privacy-policy" style={{ color: '#007bff', textDecoration: 'none' }}>
          Privacy Policy
        </Link>
      </p>
    </div>
  );
};

export default SignIn;
